import { createContext, useContext } from 'react';

export const ClientSideBootingFinishedContext = createContext<boolean>(false);

export const useClientSideBootingFinished = (): boolean => {
  return useContext(ClientSideBootingFinishedContext);
};
